<!-- Vertical layout -->
<ng-scrollbar style="height: calc(100vh - 60px)" visibility="hover" id="nav-ps-mantis">
  <div class="navbar-content">
    <ul class="nav coded-inner-navbar" (clickOutside)="fireOutClick()" (mouseleave)="navMob()">
      @for (item of navigations; track item) {
        @if (item.type === 'group') {
          <app-nav-group [item]="item"></app-nav-group>
        }
      }
    </ul>
  </div>
</ng-scrollbar>
